import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { VISIBLE_PRODUCT_REVIEW_CARDS } from '../../const/digitContants'
import style from './Listing.module.sass'

type LoaderListingReviewProps = {
	bannerType: JSX.Element
	amount?: number
}

export const LoaderListingReview: FunctionComponent<LoaderListingReviewProps> = ({
	bannerType,
	amount = VISIBLE_PRODUCT_REVIEW_CARDS,
}) => {
	return (
		<div className={style.bannerGroup}>
			{[...Array(amount)].map((_, index) => (
				<div key={index} className={clsx(style.cardWrapper, style.cardWrapperLoading)}>
					{bannerType}
				</div>
			))}
		</div>
	)
}
